import { Route } from '@angular/router';
import { AuthCallbackComponent, AuthGuard } from '@authentication';
import { HEADER_ATTACHED_ROUTE_DATA } from './constants/layout.constant';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SymbolDetailComponent } from './modules/symbol-details/symbol-detail.component';
import { MarketComponent } from './modules/market/market.component';
import { MenuComponent } from './modules/menu/menu.component';
import { OrderFormComponent } from './modules/order-form/order-form.component';
import { OrdersComponent } from './modules/orders/orders.component';
import { PortfolioComponent } from './modules/portfolio/portfolio.component';
import { WalletComponent } from './modules/wallet/wallet.component';

export const appRoutes: Route[] = [
	{ path: '', redirectTo: 'market', pathMatch: 'full' },
	{ path: 'wallet', component: WalletComponent, canActivate: [AuthGuard] },
	{
		// Nested under `wallet` so the footer keeps the کیف پول tab lit on the form.
		path: 'wallet/withdraw',
		loadComponent: () => import('./modules/wallet/withdraw/withdraw.component').then(m => m.WithdrawComponent),
		canActivate: [AuthGuard]
	},
	{
		// The mirror of `wallet/withdraw`, nested the same way for the same reason.
		path: 'wallet/deposit',
		loadComponent: () => import('./modules/wallet/deposit/deposit.component').then(m => m.DepositComponent),
		canActivate: [AuthGuard]
	},
	{
		// Nested under `wallet` like the other two money forms, for the same reason.
		path: 'wallet/transfer',
		loadComponent: () => import('./modules/wallet/transfer/transfer.component').then(m => m.TransferComponent),
		canActivate: [AuthGuard]
	},
	{
		path: 'wallet/transfer-history',
		loadComponent: () =>
			import('./modules/wallet/transfer-history/wallet-transfer-history.component').then(
				m => m.WalletTransferHistoryComponent
			),
		canActivate: [AuthGuard]
	},
	{
		path: 'portfolio',
		component: PortfolioComponent,
		canActivate: [AuthGuard],
		data: { [HEADER_ATTACHED_ROUTE_DATA]: true }
	},
	{
		// The holding is addressed by contractId — the identity `/portfolios/deposit`
		// and the market feed agree on, and the key the detail is fetched by.
		path: 'portfolio/:contractId',
		loadComponent: () =>
			import('./modules/portfolio/portfolio-detail/portfolio-detail.component').then(
				m => m.PortfolioDetailComponent
			),
		canActivate: [AuthGuard]
	},
	{ path: 'orders', component: OrdersComponent, canActivate: [AuthGuard] },
	{
		// A read-only summary of the trading day, reached from the orders header's «بیشتر» menu.
		path: 'orders/today-activity',
		loadComponent: () =>
			import('./modules/orders/today-activity/today-activity.component').then(m => m.TodayActivityComponent),
		canActivate: [AuthGuard]
	},
	{
		path: 'orders/history',
		loadComponent: () =>
			import('./modules/orders/order-history/order-history.component').then(m => m.OrderHistoryComponent),
		canActivate: [AuthGuard]
	},
	{
		path: 'transactions',
		loadComponent: () => import('./modules/transactions/transactions.component').then(m => m.TransactionsComponent),
		canActivate: [AuthGuard]
	},
	{
		path: 'physical-delivery',
		loadComponent: () =>
			import('./modules/physical-delivery/physical-delivery.component').then(m => m.PhysicalDeliveryComponent),
		canActivate: [AuthGuard]
	},
	{
		path: 'physical-delivery/request',
		loadComponent: () =>
			import('./modules/physical-delivery/request/physical-delivery-request.component').then(
				m => m.PhysicalDeliveryRequestComponent
			),
		canActivate: [AuthGuard]
	},
	{ path: 'market', component: MarketComponent, canActivate: [AuthGuard] },
	{ path: 'menu', component: MenuComponent, canActivate: [AuthGuard] },
	{
		// حساب کاربری brings its own children (دستگاه‌های فعال), so the routes live
		// with the feature.
		path: 'account',
		loadChildren: () => import('./modules/account/account.routes').then(m => m.accountRoutes)
	},
	{
		// تنظیمات carries its own `canDeactivate`, so the routes live with the
		// feature rather than being restated here.
		path: 'settings',
		loadChildren: () => import('./modules/settings/settings.routes').then(m => m.settingsRoutes)
	},
	{
		path: 'symbol-details/:symbolIsin',
		component: SymbolDetailComponent,
		canActivate: [AuthGuard],
		data: { [HEADER_ATTACHED_ROUTE_DATA]: true }
	},
	{
		// ایزی چارت — bare from the سایر page, which opens it on شمش طلا.
		path: 'easy-chart',
		loadComponent: () => import('./modules/easy-chart/easy-chart.component').then(m => m.EasyChartComponent),
		canActivate: [AuthGuard]
	},
	{
		// …and on a symbol's own isin from that symbol's board.
		path: 'easy-chart/:symbolIsin',
		loadComponent: () => import('./modules/easy-chart/easy-chart.component').then(m => m.EasyChartComponent),
		canActivate: [AuthGuard]
	},
	{
		path: 'order-form/:isin/:orderSide',
		component: OrderFormComponent,
		canActivate: [AuthGuard],
		data: { [HEADER_ATTACHED_ROUTE_DATA]: true }
	},
	{
		path: 'order-form/:isin/:orderSide/:quantity',
		component: OrderFormComponent,
		canActivate: [AuthGuard],
		data: { [HEADER_ATTACHED_ROUTE_DATA]: true }
	},
	{
		path: 'auth-callback',
		component: AuthCallbackComponent
	},
	{
		path: 'not-found',
		component: NotFoundComponent
	},
	{
		path: '**',
		redirectTo: 'not-found'
	}
];
